<template>
  <path
    d="M22 4.00024C22 2.90024 21.1 2.00024 20 2.00024H4C2.9 2.00024 2 2.90024 2 4.00024V16.0002C2 17.1002 2.9 18.0002 4 18.0002H18L22 22.0002V4.00024ZM16 11.0002H13V14.0002C13 14.5502 12.55 15.0002 12 15.0002C11.45 15.0002 11 14.5502 11 14.0002V11.0002H8C7.45 11.0002 7 10.5502 7 10.0002C7 9.45024 7.45 9.00024 8 9.00024H11V6.00024C11 5.45024 11.45 5.00024 12 5.00024C12.55 5.00024 13 5.45024 13 6.00024V9.00024H16C16.55 9.00024 17 9.45024 17 10.0002C17 10.5502 16.55 11.0002 16 11.0002Z"
  />
</template>
